import { useModal } from '@/contexts/modal'
import AddIcons from '@/icons/AddIcons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'vnetwork-ui'

interface ICloneProps {
    contractID: number
}
const RetentionComponent: React.FC<ICloneProps> = ({ contractID = 0 }) => {
    const { t } = useTranslation('contract')

    const { open, setModal } = useModal()

    return (
        <>
            <Button
                size="small"
                variant="outlined"
                startIcon={<AddIcons />}
                onClick={() =>
                    setModal<CreatePartnerSubcontractModalProps>(
                        'ContractModals/CreatePartnerSubcontractModal/index',
                        {
                            contractID: contractID,
                        }
                    )
                }
                disabled={open}
            >
                {t('subcontract-create')}
            </Button>
            {/* {create && <Dialog open={true}></Dialog>} */}
        </>
    )
}

import { CreatePartnerSubcontractModalProps } from '@/modals/ContractModals/CreatePartnerSubcontractModal'

const CreatePartnerSubcontract = (props: ICloneProps) => {
    return <RetentionComponent {...props} />
}
export default CreatePartnerSubcontract
